export default {
  APC: "Asia-Pacific",
  ECA: "Other Europe & Central Asia",
  MNA: "Middle East & North Africa",
  SSA: "Sub-Saharan Africa",
  LAC: "Latin America & Caribbean",
  ROW: "Rest of the World",
  EUE: "Europe 30",
  GCH: "Greater China",
  NAC: "North America",
  WLD: "World",
  NES: "Not specified",
} as const;
